import script from "./Duraciones.vue?vue&type=script&setup=true&lang=js"
export * from "./Duraciones.vue?vue&type=script&setup=true&lang=js"

import "./Duraciones.vue?vue&type=style&index=0&id=612fd194&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-612fd194"]])

export default __exports__